export default __webpack_public_path__ + "static/media/Portadas-Blog-GAMA-1-2-768x576.761e0483.webp";